module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/babel-runtime/core-js/object/keys.js
// module id = P/cQ
// module chunks = 0